import Tabs from './components/tabs';
import ScrollToElement from './components/ScrollToElement';
import $ from 'jquery';
import 'videojs';

// Hero scroll to HIW link
document.addEventListener('DOMContentLoaded', () => {
    let element = document.querySelector('[data-endless-opportunities]');
    new ScrollToElement(element).handleClick();
});

// Tabs
document.addEventListener('DOMContentLoaded', () => {
    let element = document.querySelector('[data-tabs]');
    new Tabs(element);
});



// WEBPACK FOOTER //
// ./js/marketing/designers.js